import { constants } from '../config/constants';

const DEFAULT_SESSION_HOURS = 12;

function parseNumber(value) {
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return null;
  return numberValue;
}

function normalizeStoredString(value) {
  const normalized = String(value ?? '').trim();
  if (!normalized || normalized === 'null' || normalized === 'undefined') {
    return '';
  }
  return normalized;
}

export function clearSessionStorage() {
  localStorage.removeItem(constants.USER_ID);
  localStorage.removeItem(constants.ROLE);
  localStorage.removeItem(constants.USERNAME);
  localStorage.removeItem(constants.AUTH_TOKEN);
  localStorage.removeItem(constants.SESSION_EXPIRES_AT);
}

export function startSession(hours = DEFAULT_SESSION_HOURS) {
  const expiresAt = Date.now() + hours * 60 * 60 * 1000;
  localStorage.setItem(constants.SESSION_EXPIRES_AT, String(expiresAt));
  return expiresAt;
}

export function getSessionExpiresAt() {
  return parseNumber(localStorage.getItem(constants.SESSION_EXPIRES_AT));
}

export function setAuthToken(token) {
  if (!token) return;
  localStorage.setItem(constants.AUTH_TOKEN, String(token));
}

export function getAuthToken() {
  const token = localStorage.getItem(constants.AUTH_TOKEN);
  if (!token || token === 'null' || token === 'undefined') return null;
  return token;
}

export function getStoredUserRole() {
  return normalizeStoredString(localStorage.getItem(constants.ROLE));
}

export function isAdminRole(role = '') {
  const normalizedRole = normalizeStoredString(role) || getStoredUserRole();
  const roleName = normalizedRole.toLowerCase();
  return roleName === 'admin' || roleName === 'administrador';
}

export function isSuperadminRole(role = '') {
  const normalizedRole = normalizeStoredString(role) || getStoredUserRole();
  return normalizedRole.toLowerCase() === 'superadmin';
}

export function isReviewerRole(role = '') {
  const normalizedRole = normalizeStoredString(role) || getStoredUserRole();
  return normalizedRole.toLowerCase() === 'revisor';
}

export function isLogisticsRole(role = '') {
  const normalizedRole = normalizeStoredString(role) || getStoredUserRole();
  return normalizedRole
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase() === 'logistico';
}

export function getSessionHomeRoute(role = '') {
  if (isSuperadminRole(role)) return '/superadmin';
  if (isAdminRole(role)) return '/administrador';
  if (isReviewerRole(role)) return '/revisor';
  if (isLogisticsRole(role)) return '/logistica';
  return '/';
}

export function hasActiveSession() {
  const userId = localStorage.getItem(constants.USER_ID);
  const role = localStorage.getItem(constants.ROLE);
  const userName = localStorage.getItem(constants.USERNAME);
  const authToken = getAuthToken();
  const expiresAt = getSessionExpiresAt();

  const hasUserData =
    Boolean(userId) &&
    userId !== 'null' &&
    Boolean(role) &&
    role !== 'null' &&
    Boolean(userName) &&
    userName !== 'null' &&
    Boolean(authToken);

  if (!hasUserData || !expiresAt) {
    clearSessionStorage();
    return false;
  }

  const stillActive = Date.now() < expiresAt;
  if (!stillActive) {
    clearSessionStorage();
    return false;
  }

  return true;
}
